import { createFeatureSelector, createSelector } from '@ngrx/store';

import { LoginAnalyticsState } from '../reducers/login-analytics.reducers';

export const getLoginAnalyticsStore =
  createFeatureSelector<LoginAnalyticsState>('login-analytics');

export const getLoginAnalyticsMethod = createSelector(
  getLoginAnalyticsStore,
  (state: LoginAnalyticsState) => state.method,
);

export const getLoginAnalyticsData = createSelector(
  getLoginAnalyticsStore,
  (state: LoginAnalyticsState) => state,
);
